import { useCallback } from "react";
import { Task } from "@common/types/task";
import { Button } from "@design-system/Button/Button";
import { useToaster } from "@design-system/ToastMessages/useToaster";
import { useStateAwareNavigate } from "@hooks/useStateAwareNavigate";
import styles from "./CreateTaskDrawer.module.scss";

export function useCreatedTaskToast() {
    const { toast, dismiss } = useToaster();
    const navigate = useStateAwareNavigate();

    return useCallback(
        (task: Task) => {
            const toastId = toast(
                <div className={styles.createdTaskToast}>
                    <span>{`Created task ${task.title}`}</span>
                    <Button
                        variant="primary"
                        size="sm"
                        onClick={() => {
                            dismiss(toastId);
                            navigate(`/?taskId=${task.id}`);
                        }}
                    >
                        View task
                    </Button>
                </div>,
            );
        },
        [toast, dismiss, navigate],
    );
}
